import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useCartSummary } from "../context/CartContext";

export default function Header() {
  const { auth, logout } = useAuth();
  const { totalQty } = useCartSummary();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  // QR오더 화면(/order/:qrToken)은 관리자 사이트에서 이관된 완전히 독립된 화면이라
  // 자체 헤더(.to-header)를 이미 갖고 있다 - 사이트 공용 헤더가 그 위에 겹쳐 보이면
  // 안 되므로 이 경로에서는 헤더 자체를 렌더링하지 않는다.
  if (location.pathname.startsWith("/order/")) {
    return null;
  }

  return (
    <header className="site-header">
      <Link to="/" className="brand brand-inline">
        <img src="/onetak-icon.svg" alt="onetak" className="brand-icon" />
        <div className="brand-mark">one<span>tak</span></div>
      </Link>

      <nav className="site-nav">
        <Link to="/">홈</Link>
        <Link to="/products">상품</Link>
        <Link to="/cart" className="cart-link">
          장바구니{totalQty > 0 && <span className="cart-badge">{totalQty}</span>}
        </Link>
        {auth && <Link to="/reservation">예약</Link>}
        {auth && <Link to="/orders">주문내역</Link>}
        {auth ? (
          <>
            <span className="nav-user">{auth.memberName}님</span>
            <button type="button" className="link-btn" onClick={handleLogout}>로그아웃</button>
          </>
        ) : (
          <Link to="/login">로그인</Link>
        )}
      </nav>
    </header>
  );
}
